import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import _data from './info.json';
import SocialFollow from './SocialFollow';
import { DataType } from './types';
import usePageMeta from './usePageMeta';
import WorkPanel from './WorkPanel';

const data = _data as DataType;

export default function WorkPage() {
  usePageMeta(
    'Work',
    'Berlin-based designer and maker Yoav Reches works between digital manufacturing and craft, creating precise sculptural objects shaped by rich material processes.',
    'work',
  );

  return (
    <>
      <WorkPanel projects={data.projects} />;
      <SocialFollow />
    </>
  );
}
